import { Routes } from '@angular/router';
import { PersonasLayoutComponent } from './layouts/personas-layout/personas-layout.component';
import { IngresoComponent } from './features/personas/ingreso/ingreso.component';
import { VerificacionOtpComponent } from './features/personas/verificacion-otp/verificacion-otp.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'personas/inicio' },

  { path: 'personas/ingreso/verificacion', component: VerificacionOtpComponent, pathMatch: 'full' },
  { path: 'personas/ingreso', component: IngresoComponent, pathMatch: 'full' },
  /* Misma superficie que verificación OTP: fuera del layout (sin sidebar) */
  {
    path: 'personas/validacion-telefono',
    loadComponent: () =>
      import('./features/personas/validacion-telefono/validacion-telefono.component').then(
        m => m.ValidacionTelefonoComponent
      ),
    pathMatch: 'full'
  },
  {
    path: 'personas/validacion-email',
    loadComponent: () =>
      import('./features/personas/validacion-email/validacion-email.component').then(
        m => m.ValidacionEmailComponent
      ),
    pathMatch: 'full'
  },

  {
    path: 'personas',
    component: PersonasLayoutComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'inicio' },
      { path: 'inicio', loadComponent: () => import('./features/personas/inicio/inicio.component').then(m => m.InicioComponent) },
      { path: 'mis-datos', loadComponent: () => import('./features/personas/mis-datos/mis-datos.component').then(m => m.MisDatosComponent) },
      { path: 'nuevo-desembolso', loadComponent: () => import('./features/personas/nuevo-desembolso/nuevo-desembolso.component').then(m => m.NuevoDesembolsoComponent) },
      { path: 'documentos-credito', loadComponent: () => import('./features/personas/documentos-credito/documentos-credito.component').then(m => m.PersonasDocumentosComponent) },
      { path: 'proceso-terminado', loadComponent: () => import('./features/personas/proceso-terminado/proceso-terminado.component').then(m => m.PersonasProcesoTerminadoComponent) },
      { path: 'transacciones', loadComponent: () => import('./features/personas/transacciones/transacciones.component').then(m => m.TransaccionesComponent) },
      { path: 'creditos', loadComponent: () => import('./features/personas/creditos/creditos.component').then(m => m.PersonasCreditosComponent) }
    ]
  },

  { path: '**', redirectTo: 'personas/inicio' }
];
